import { useState, useCallback } from 'react';
import AuthService from '../services/authService';
import { API_BASE } from '../config/api';

/**
 * Re-send the email-verification link. Shared by the verify banner and the
 * "Verify your email" row on the phone menu (/you), so both report the same
 * states: 'idle' | 'sending' | 'sent' | 'error'.
 */
export default function useResendVerification() {
  const [sendState, setSendState] = useState('idle');

  const resend = useCallback(async () => {
    setSendState('sending');
    try {
      const response = await fetch(`${API_BASE}/api/auth/resend-verification`, {
        method: 'POST',
        headers: AuthService.getJsonHeaders()
      });
      const data = await response.json();
      setSendState(data.success ? 'sent' : 'error');
    } catch (err) {
      console.error('Resend verification failed:', err);
      setSendState('error');
    }
  }, []);

  return { sendState, resend };
}

/**
 * Whether the signed-in user is KNOWN to be unverified. The signin/signup
 * responses omit emailVerified (only /api/auth/me includes it), so undefined
 * must not read as unverified, or verified users would see the nudge flash.
 */
export function isKnownUnverified(user) {
  return !!user && (user.emailVerified === 0 || user.emailVerified === false);
}
